import { useControllableState } from '@doppio/core';
import * as React from 'react';
const PopoverContext = React.createContext(undefined);
export const usePopover = () => React.useContext(PopoverContext);
export const Popover = ({ defaultOpen, onOpenChange, children, ...props }) => {
    const [isOpen, setOpen] = useControllableState({
        value: props.isOpen,
        defaultValue: defaultOpen,
        onChange: onOpenChange,
    });
    const triggerRef = React.useRef(null);
    return (React.createElement(PopoverContext.Provider, { value: {
            triggerRef,
            isOpen,
            onOpenChange: setOpen,
        } }, children));
};
Popover.displayName = 'Popover';
//# sourceMappingURL=Popover.js.map